import axiosClient, { cache } from "../../network";

export default class authenticationService {
  static login(payload) {
    return axiosClient
      .post("/user/login", payload)
      .then(({ data }) => {
        return cache.store
          .clear()
          .then(() => {
            return data;
          })
          .catch((err) => {
            console.log(err);
            return data;
          });
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static refreshLogin(payload) {
    let thirdPartyToken = null;
    if (payload?.thirdPartyToken) {
      thirdPartyToken = {
        headers: {
          "third-party-token": payload?.thirdPartyToken
        }
      };
    }
    return axiosClient
      .get("/user/refreshToken", thirdPartyToken)
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static signUp(payload) {
    return axiosClient
      .post("/user/signUp", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static async verifyEmail(payload) {
    return axiosClient
      .post("/user/verifyEmail", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static verifyPasswordToken(payload) {
    return axiosClient
      .post("/user/verifyPasswordToken", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static forgotPassword(payload) {
    return axiosClient
      .post("/user/forgotPassword", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getMetamaskUser(payload) {
    return axiosClient
      .post("/user/metamask/getNonce", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static verifyMetamaskSignature(payload) {
    return axiosClient
      .post("/user/metamask/verifySignature", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static async sbInitilize(payload) {
    const config = {
      headers: {
        token: payload.token
      }
    };
    const url = `${process.env.REACT_APP_SPORTSBOOK_API_URL}/initialize?unique_id=${process.env.REACT_APP_SPORTS_IFRAME_ID}`;
    return axiosClient
      .get(url, config)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static thirdPartyLogin(payload) {
    return axiosClient
      .get("/user/crossAuthentication", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
